// extracted by mini-css-extract-plugin
export default {"characters":"Characters_characters__I3zB2","filters":"Characters_filters__pxlYz"};